import React, {useEffect, useState} from "react";
import Slide from "@mui/material/Slide";
import {Button, Dialog, Grid, TextField} from "@material-ui/core";
import Box from "@mui/material/Box";
import AsyncAutocomplete from "../common/AsyncAutocomplete";
import {getAllShippingCompanies, getAllShippingOptions} from "../../services/shippingService";
import AppBar from "@mui/material/AppBar";
import {primary} from "../../theme";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {DialogActions} from "@mui/material";

import SendIcon from '@mui/icons-material/Send';
import {getAllCustomers} from "../../services/customerService";
import {getAllDevices} from "../../services/deviceService";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
export const EmailTestDialog = ({
                                    open,
                                    handleClose,
                                    selectedTemplate,
                                    sendEmail,
                                }) => {
    const [data, setData] = useState({template: selectedTemplate,});
    useEffect(() => {
        setData({template: selectedTemplate})
    }, [open]);
    return (
        <Dialog
            fullWidth={true}
            maxWidth={"md"}
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar sx={{position: 'relative', bgcolor: primary}}>
                <Toolbar>
                    <Typography sx={{ml: 2, flex: 1}} variant="h6" component="div">
                        Testowa wiadomość
                    </Typography>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                        style={{postion: 'absoulte'}}
                    >
                        <CloseIcon/>
                    </IconButton>
                </Toolbar>
            </AppBar><Box sx={{padding: '40px'}}>
            <Box sx={{paddingBottom: "20px"}}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <AsyncAutocomplete getData={getAllCustomers}
                                           onChange={(e) => {
                                               setData({...data, contractor: e.uuid})
                                           }}
                                           label={"Kontrahent"}
                                           variant={"outlined"}
                                           optionLabel={(option) => option.name}/>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField style={{width: "100%",}}
                                   label="Email"
                                   variant="outlined"
                                   size={"medium"}
                                   onChange={(e) => {setData({...data, email: e.target.value})}} />
                    </Grid>
                    <Grid item xs={6}>
                        <AsyncAutocomplete getData={getAllDevices}
                                           onChange={(e) => {
                                               setData({...data, device: e.uuid})
                                           }}
                                           label={"Urządzenie"}
                                           variant={"outlined"}
                                           optionLabel={(option) => option.name}/>
                    </Grid>
                    <Grid item xs={6}>
                        <AsyncAutocomplete getData={getAllShippingCompanies}
                                           onChange={(e) => {
                                               setData({...data, shipping_company: e.uuid})
                                           }}
                                           label={"Firma wysyłkowa"}
                                           variant={"outlined"}
                                           optionLabel={(option) => option.name}/>
                    </Grid>
                </Grid>
            </Box>
        </Box>
            <DialogActions>
                <Button onClick={() => sendEmail(data)}>
                    <SendIcon/> Wyślij
                </Button>

            </DialogActions>
        </Dialog>)
}